export const REVIEW_DEFAULT_PROMPTS: Record<'weekly' | 'monthly' | 'yearly', string[]> = {
  weekly: [
    'What were your biggest wins this week?',
    'What key lessons or insights did you gain this week?',
    'What are your main intentions for the upcoming week?',
  ],
  monthly: [
    'What are you most proud of accomplishing this month?',
    'What were your most valuable insights or realizations this month?',
    'What is your vision for the upcoming month?',
  ],
  yearly: [
    'What is your vision for this year? What do you want to achieve?',
    'What are the 3-5 major goals you want to accomplish this year?',
    'If you had to give this year a theme or word, what would it be?',
  ],
};

export const PROMPT_CATEGORIES = [
  'weekly_retrospective',
  'weekly_forward',
  'monthly_retrospective',
  'monthly_forward',
  'yearly',
  'start_day',
  'end_day',
  'general',
] as const;

export type PromptCategory = typeof PROMPT_CATEGORIES[number];

export const DEFAULT_PROMPT_SETS: Record<PromptCategory, string[]> = {
  weekly_retrospective: [
    'What were your biggest wins this week?',
    'What challenges did you face and how did you handle them?',
    'What key lessons or insights did you gain this week?',
    'What are you most grateful for from this past week?',
    'How did you grow or improve as a person this week?',
  ],
  weekly_forward: [
    'What are your main intentions for the upcoming week?',
    'What are your top 3 priorities for next week?',
    'What habits or routines do you want to establish or maintain?',
    'What deserves your focused attention this week?',
    'What do you need to prepare or plan for this week?',
  ],
  monthly_retrospective: [
    'What are you most proud of accomplishing this month?',
    'What important milestones or progress did you make?',
    'What were your most valuable insights or realizations this month?',
    'How did your relationships evolve or deepen this month?',
    'What obstacles did you overcome and what did they teach you?',
  ],
  monthly_forward: [
    'What is your vision for the upcoming month?',
    'What are your key objectives to accomplish next month?',
    'What areas of growth do you want to focus on?',
    'What commitments are you making to yourself for next month?',
    'What are you most excited about for the coming month?',
  ],
  yearly: [
    'What is your vision for this year? What do you want to achieve?',
    'What are your core values that will guide your decisions this year?',
    'What are the 3-5 major goals you want to accomplish this year?',
    'What key areas of your life do you want to focus on improving this year?',
    'How do you want to make a positive impact this year?',
    'What do you want to learn or how do you want to grow personally this year?',
    'How do you want to invest in and improve your relationships this year?',
    'What are your professional and career goals for this year?',
    'What are your health and wellness goals for this year?',
    'How do you want to contribute to your community or causes you care about?',
    'What challenges or obstacles do you anticipate, and how will you overcome them?',
    'If you had to give this year a theme or word, what would it be?',
  ],
  start_day: [
    'What is my main intention for today?',
    'What are the most important things I want to accomplish today?',
    'How can I best manage my energy throughout the day?',
    'What mindset will serve me best today?',
    'How will I take care of myself today?',
    'What challenges might I face today and how can I prepare?',
  ],
  end_day: [
    'What went well today?',
    'What could I have done better today?',
    'What did I learn today?',
    'What am I grateful for from today?',
    'What am I proud of from today?',
    'What do I want to remember for tomorrow?',
  ],
  general: [
    'How am I feeling right now?',
    'What can I do to refresh myself right now?',
    'What are the most important things I need to get to today?',
    'How is my energy level and what do I need?',
    'What am I noticing in this present moment?',
    'What small wins can I achieve right now?',
  ],
};
